import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PromDatesService {
  public startDate!:any;
  public endDate!:any;
  constructor() { }

  validProm(start:string, end:string, current:Date){
    if (start && end) {
      this.transDate(start, end);
      if (this.startDate <= current && this.endDate >= current) {
        return true;  
      }else{
        return false;
      }
    }else if(start){
      this.transDate(start, end);
      if (current >= this.startDate) {
        return true;
      }else{
        return false;
      }
    }else if (end) {
      this.transDate(start, end);
      if(this.endDate >= current){
        return true;
      }else{
        return false;
      }
    }else{
      return false;
    }
  }

  transDate(start?:string, end?:string){
    if (start && end) {
      const splDateInit = start.split('-');
      const splDateEnd = end.split('-');
      this.startDate = new Date(parseInt(splDateInit[0]), parseInt(splDateInit[1])-1, parseInt(splDateInit[2]));
      this.endDate = new Date(parseInt(splDateEnd[0]), parseInt(splDateEnd[1])-1, parseInt(splDateEnd[2]));
      this.startDate.setHours(0o0, 0o0, 0o0, 0o0);
      this.endDate.setHours(23, 59, 59, 0);
    } else if (start) {
      const splDateInit = start.split('-');
      this.startDate = new Date(parseInt(splDateInit[0]), parseInt(splDateInit[1])-1, parseInt(splDateInit[2]));
      this.startDate.setHours(0o0, 0o0, 0o0, 0o0);
    }else if (end) {
      const splDateEnd = end.split('-');
      this.endDate = new Date(parseInt(splDateEnd[0]), parseInt(splDateEnd[1])-1, parseInt(splDateEnd[2]));
      this.endDate.setHours(23, 59, 59, 0);
    }
  }
}
